import { colors } from "../../../constants";

const { GRECIAN_GREY } = colors;

const bannerBackgroundColor = GRECIAN_GREY;

export const fallbackValues = {
  bannerBackgroundColor
};
